"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONExporter = void 0;
var common_1 = require("@devexpress/utils/lib/utils/common");
var json_document_enums_1 = require("../enums/json-document-enums");
var json_section_enums_1 = require("../enums/json-section-enums");
var json_sub_document_enums_1 = require("../enums/json-sub-document-enums");
var json_masked_character_properties_converter_1 = require("../importers/json-masked-character-properties-converter");
var json_masked_paragraph_properties_converter_1 = require("../importers/json-masked-paragraph-properties-converter");
var json_section_properties_converter_1 = require("../importers/section/json-section-properties-converter");
var json_table_cell_properties_converter_1 = require("../importers/table/json-table-cell-properties-converter");
var json_table_properties_converter_1 = require("../importers/table/json-table-properties-converter");
var json_table_row_properties_converter_1 = require("../importers/table/json-table-row-properties-converter");
var json_control_options_converter_1 = require("./json-control-options-converter");
var JSONExporter = (function () {
    function JSONExporter() {
    }
    JSONExporter.exportDocumentProperties = function (documentModel) {
        var result = {};
        result[json_document_enums_1.JSONDocumentPropertiesProperty.DefaultTabWidth] = documentModel.defaultTabWidth;
        result[json_document_enums_1.JSONDocumentPropertiesProperty.DifferentOddAndEvenPages] = common_1.boolToInt(documentModel.differentOddAndEvenPages);
        result[json_document_enums_1.JSONDocumentPropertiesProperty.DisplayBackgroundShape] = common_1.boolToInt(documentModel.displayBackgroundShape);
        result[json_document_enums_1.JSONDocumentPropertiesProperty.PageBackColor] = documentModel.pageBackColor;
        result[json_document_enums_1.JSONDocumentPropertiesProperty.DefaultCharacterProperties] =
            json_masked_character_properties_converter_1.JSONMaskedCharacterPropertiesConverter.convertToJSON(documentModel.defaultCharacterProperties);
        result[json_document_enums_1.JSONDocumentPropertiesProperty.DefaultParagraphProperties] =
            json_masked_paragraph_properties_converter_1.JSONMaskedParagraphPropertiesConverter.convertToJSON(documentModel.defaultParagraphProperties);
        result[json_document_enums_1.JSONDocumentPropertiesProperty.DefaultTableProperties] =
            json_table_properties_converter_1.JSONTablePropertiesConverter.convertToJSON(documentModel.defaultTableProperties);
        result[json_document_enums_1.JSONDocumentPropertiesProperty.DefaultTableRowProperties] =
            json_table_row_properties_converter_1.JSONTableRowPropertiesConverter.convertToJSON(documentModel.defaultTableRowProperties);
        result[json_document_enums_1.JSONDocumentPropertiesProperty.DefaultTableCellProperties] =
            json_table_cell_properties_converter_1.JSONTableCellPropertiesConverter.convertToJSON(documentModel.defaultTableCellProperties);
        return result;
    };
    JSONExporter.exportModelHeaderFooter = function (headersFooters) {
        var jsonHeadersFooters = [];
        for (var _i = 0, headersFooters_1 = headersFooters; _i < headersFooters_1.length; _i++) {
            var headerFooter = headersFooters_1[_i];
            var jsonHeaderFooter = {};
            jsonHeaderFooter[json_sub_document_enums_1.JSONHeaderFooterInfoProperty.Type] = headerFooter.getType();
            jsonHeaderFooter[json_sub_document_enums_1.JSONHeaderFooterInfoProperty.SubDocumentId] = headerFooter.subDocumentId;
            jsonHeadersFooters.push(jsonHeaderFooter);
        }
        return jsonHeadersFooters;
    };
    JSONExporter.exportSections = function (documentModel) {
        var result = [];
        for (var _i = 0, _a = documentModel.sections; _i < _a.length; _i++) {
            var section = _a[_i];
            var jsonSection = {};
            jsonSection[json_section_enums_1.JSONSection.StartPos] = section.startLogPosition.value;
            jsonSection[json_section_enums_1.JSONSection.Length] = section.getLength();
            jsonSection[json_section_enums_1.JSONSection.Properties] = json_section_properties_converter_1.JSONSectionPropertiesConverter.convertToJSON(section.sectionProperties);
            jsonSection[json_section_enums_1.JSONSection.Headers] = this.exportHeaderFooter(section.headers);
            jsonSection[json_section_enums_1.JSONSection.Footers] = this.exportHeaderFooter(section.footers);
            result.push(jsonSection);
        }
        return result;
    };
    JSONExporter.exportHeaderFooter = function (headersFooters) {
        var _a;
        var jsonHeadersFooters = {};
        for (var type in headersFooters) {
            if (Object.prototype.hasOwnProperty.call(headersFooters, type)) {
                jsonHeadersFooters[type] = (_a = {},
                    _a[json_sub_document_enums_1.JSONHeaderFooterInfoProperty.Type] = parseInt(type),
                    _a[json_sub_document_enums_1.JSONHeaderFooterInfoProperty.SubDocumentId] = headersFooters[type].subDocumentId,
                    _a);
            }
        }
        return jsonHeadersFooters;
    };
    JSONExporter.exportOptions = function (controlOptions) {
        var result = {};
        result = json_control_options_converter_1.JSONControlOptionsConverter.convertToJSON(controlOptions);
        return result;
    };
    return JSONExporter;
}());
exports.JSONExporter = JSONExporter;
